import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"margin-top":"6em"} }
const _hoisted_2 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_3 = {
  href: "https://metaxar.io",
  class: "text-red-600 mb-3 mt-4 text-md hover:underline"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" metaxar.io")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Back to home")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Back to home ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-text text-sm" }, " © Copyright 2023 MetaXar. All rights reserved. ", -1)
const _hoisted_9 = { class: "flex-grow h-12 flex items-center justify-center content-center" }
const _hoisted_10 = { class: "flex content-center justify-center items-center text-gray-text" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Powered by ")
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "text-xs text-gray-text mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    (_ctx.activeSection === 'username')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-solid fa-home",
              class: "inline-block"
            }),
            _hoisted_4
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.$route.name === 'viewAuthLogin')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitToUsername())),
                class: "cursor-pointer text-red-600 mb-3 mt-4 text-md"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-home",
                  class: "inline-block"
                }),
                _hoisted_6
              ]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: {name: 'viewAuthLogin'},
                class: "text-red-600 mb-2 mt-4 hover:underline block text-md"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-home text-red-500" }),
                  _hoisted_7
                ]),
                _: 1
              }))
        ])),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("img", {
          src: require('@/assets/images/sirius-chain.png'),
          class: "pt-2 px-3 relative -top-1 h-7"
        }, null, 8, _hoisted_12)
      ])
    ]),
    _createElementVNode("p", _hoisted_13, "v" + _toDisplayString(_ctx.appVersion), 1)
  ]))
}